import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { ElectricitySavingsService } from "@services/electricity-savings-service.ts";
import {
  SimpleSavingsOptions,
  SolarSavingsOptions,
} from "@givenergy/sales-simple-energy-comparison";

export const useElectricitySavings = (
  userId: string,
  useSolarCalculation: boolean,
  options: SimpleSavingsOptions & SolarSavingsOptions,
  isEnabled: boolean = true,
) => {
  return useQuery({
    queryKey: [
      "simple-savings",
      userId,
      useSolarCalculation,

      options?.householdInformation?.postcode,
      options?.householdInformation?.hasEv,
      options?.householdInformation?.meterType,
      options?.householdInformation?.houseType,
      options?.householdInformation?.heatingType,
      options?.householdInformation?.annualConsumptionKwh,
      options?.householdInformation?.gridKwh?.import,
      options?.householdInformation?.gridKwh?.import,

      // These objects get rebuilt everytime they update, so this should be safe
      options?.lastYearsTariff,
      options?.comparisonTariff,

      options?.systemConfiguration?.batteryCapacity,

      options?.solarConfiguration?.hasSolar,
      options?.solarConfiguration?.solarArraySize,
    ],
    queryFn: async () => {
      const salesService = new ElectricitySavingsService();
      if (
        useSolarCalculation &&
        options?.solarConfiguration?.hasSolar === "Yes"
      ) {
        return await salesService.getSolarSavings(userId, options);
      }

      return await salesService.getSimpleSavings(userId, options);
    },
    placeholderData: keepPreviousData,
    enabled: isEnabled,

    // This data doesn't really get stale or update externally, so I think an hour is reasonable here.
    // Having 1hr here means we don't excessively call the API. This will still update when invalidated from cache keys
    staleTime: 1000 * 60 * 60,
  });
};
